import { normalizeValue } from './normalizeValue'

export const getProfileValue = (profileValue?: string | null, userValue?: string | null): string =>
  normalizeValue(profileValue) || normalizeValue(userValue)
